import { Component, HostListener, Input } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';

import { CourseLectureStatus } from '../../shared/base/course-lecture-status';
import { DialogButtonBase } from '../../shared/base/dialog-button-base';
import { QuestionBase } from '../../shared/dynamic-form/shared/question-base';
import { SelectQuestion } from '../../shared/dynamic-form/shared/question-select';
import { TextAreaQuestion } from '../../shared/dynamic-form/shared/question-textarea';
import { TextboxQuestion } from '../../shared/dynamic-form/shared/question-textbox';
import { MESSAGE_COMMON_ERROR, MESSAGE_EDIT_SUCCESS } from '../../shared/message';
import { Lecture } from '../shared/lecture';
import { LectureService } from '../shared/lecture.service';

@Component({
  selector: 'app-lecture-edit-button',
  template: '<ng-content></ng-content>'
})
export class LectureEditButtonComponent extends DialogButtonBase {
  @Input() lecture: Lecture;

  constructor(dialog: MatDialog, snackBar: MatSnackBar, private service: LectureService) {
    super(dialog, snackBar);
  }

  @HostListener('click') onClick() {
    this.openDialog();
  }

  openDialog(): void {
    super.openDialog(this.title, this.questions);
  }

  async onSubmit(value: Lecture): Promise<any> {
    try {
      await this.service.update(this.lecture.$key, value);
      this.closeDialog();
      this.openSnackBar(MESSAGE_EDIT_SUCCESS);
    } catch (e) {
      this.openSnackBar(MESSAGE_COMMON_ERROR);
    }
  }

  private get title(): string {
    return '강의 편집';
  }

  private get questions(): Array<QuestionBase<any>> {
    return [
      new TextboxQuestion({
        key: 'name',
        label: '제목',
        value: this.lecture.name,
        required: true
      }),
      new SelectQuestion({
        key: 'status',
        label: '상태',
        required: true,
      }, CourseLectureStatus.getOptions(this.lecture.status)),
      new TextAreaQuestion({
        key: 'description',
        label: '간략한 설명',
        value: this.lecture.description
      })
    ];
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-edit-button/lecture-edit-button.component.ts